import {useQuery} from '@tanstack/react-query'
import {useDocumentVisible} from './use-visibility-pause.js'

/**
 * Thin wrapper around useQuery that pauses polling when the tab is hidden.
 *
 * @template T
 * @param {{
 *   queryKey: ReadonlyArray<*>,
 *   queryFn: () => Promise<T>,
 *   intervalMs: number,
 *   staleTime?: number,
 *   enabled?: boolean
 * }} options
 */
export function usePolling({queryKey, queryFn, intervalMs, staleTime, enabled = true}) {
    const visible = useDocumentVisible()
    return useQuery({
        queryKey,
        queryFn,
        staleTime,
        enabled,
        refetchInterval: visible && enabled ? intervalMs : false,
        refetchIntervalInBackground: false
    })
}
